import validation from '../../../services/validation';
import template from './has-electricity.jade';

export default angular.module('cian.addForm.commonHasElectricity', []).directive('cianAfCommonHasElectricity', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.items = [
      {
        text: 'Есть',
        value: true,
      },
      {
        text: 'Нет',
        value: false,
      },
    ];

    this.validation = validation(this.form, 'hasElectricity', {
      required: 'Обязательное поле',
    });
  },
  controllerAs: 'hasElectricity',
  template,
})).name;
